/** Remove AI-appended wellness disclaimers — the app renders these via UI i18n. */
export function stripComplianceBoilerplate(text: string): string {
  let result = text.trim()
  if (!result) return result

  const tailPatterns = [
    /\s+if you have any health concerns[\s\S]*$/i,
    /\s+kilo provides general wellness guidance only\.?\s*$/i,
    /\s+wenn du gesundheitliche bedenken[\s\S]*$/i,
    /\s+bei gesundheitlichen bedenken[\s\S]*$/i,
    /\s+wende dich bitte an (?:eine|einen|unqualifiziert(?:e|en|em|er)?)[\s\S]*$/i,
    /\s+kilo bietet nur allgemeine wellness[\s\S]*$/i,
    /\s+si vous avez des préoccupations[\s\S]*$/i,
    /\s+en cas de (?:doute|préoccupations)[\s\S]*$/i,
    /\s+kilo fournit des conseils bien-être[\s\S]*$/i,
  ]

  let changed = true
  while (changed) {
    changed = false
    for (const pattern of tailPatterns) {
      const next = result.replace(pattern, '').trim()
      if (next !== result) {
        result = next
        changed = true
      }
    }
  }

  return result.replace(/\s{2,}/g, ' ').trim()
}
